

















import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3 } from "@/components";
import productDetail from "./components/productDetail.vue"
@Component({
    components: {
        padHeadPanel3,productDetail
    },
})
export default class editProduct extends Vue {

   
    public $refs: {
    };
    id="";
    created() {
        this.id = this.$route.query.id;
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/product/editProduct.vue